import { render, staticRenderFns } from "./openApp.vue?vue&type=template&id=920968fc&scoped=true&"
import script from "./openApp.vue?vue&type=script&lang=js&"
export * from "./openApp.vue?vue&type=script&lang=js&"
import style0 from "./openApp.vue?vue&type=style&index=0&id=920968fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920968fc",
  null
  
)

export default component.exports